// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"ListA_TheComp__wQX_N","TheComp2":"ListA_TheComp2__8zBgF"};